import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    api.get("/products/areeba-multigrain-aata").then(({ data }) => setFaqs(data.faqs || [])).catch(() => {});
  }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <p className="text-wheat text-xs font-semibold uppercase tracking-widest mb-3">Help Centre</p>
      <h1 className="font-serif text-4xl font-bold text-forest-dark mb-8">Frequently Asked Questions</h1>
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`f${i}`}>
            <AccordionTrigger className="text-left font-semibold" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="text-charcoal/70">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
